<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <main id="renew3_mypage">
      <div class="mypage_back mypage_yagiprimecancel" v-if="step == 1">
        <div class="wrapper">
          <h2 class="m-h2">ヤギプライムを解約する</h2>
          <a href="/yagiprimeinfo" class="m-lead">ヤギプライムの特典を見る</a>

          <div class="my-contents">

            <div class="my-contents_container">
              <h2 class="m-h2"><span>{{ username }}</span>様はまだ<span>**</span>日間、次の更新日まで会員特典をご利用いただけます。</h2>
              <p class="m-attention">注意：会員資格を終了すると、これらの特典が利用できなくなります。</p>

              <ul class="flex list">
                <li class="item">
                  <p class="m-attention">中途・新卒の就職活動中の方には</p>
                  <p>人材紹介会社の担当エージェントが付き、会員全員が求人紹介を受けられる</p>
                </li>
                <li class="item">
                  <p class="m-attention">アルバイト・複業の求職者には</p>
                  <p>細かいカテゴライズや希望職種の設定などから常に最新の求人のレコメンドを受けられる</p>
                </li>
                <li class="item">
                  <p class="m-attention">AI志望動機（自己PR）機能が無料利用</p>
                  <p>面倒な文章作成もAIにお任せ！（GPT利用）</p>
                </li>
                <li class="item">
                  <p class="m-attention">いろんなサービスを有利に活用できる</p>
                  <p>ヤギのメール便が無料<br>
                    履歴書郵送代行が1回無料<br>
                    ヤギオファーで優先表示される<br>
                    履歴書フォント変更機能付き</p>
                </li>
              </ul>

              <div class="btn_container">
                <div class="btn01">
                  <a href="/mypage/yagiprime" class="btn01_link">特典と会員資格を継続</a>
                </div>
                <div class="btn01 btn02" v-if="false">
                  <a href="" class="btn01_link btn02_link">更新前にお知らせする</a>
                  <p class="btn-note">更新3日前にメールでお知らせします</p>
                </div>
                <div class="btn01 btn03">
                  <a href="#" @click="nextStep()" class="btn03_link">ヤギプライム会員資格を解約する</a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="mypage_back mypage_yagiprimecancel" v-else-if="step == 2">
        <div class="wrapper">
          <h2 class="m-h2">ヤギプライムを解約する</h2>
          <a href="" class="m-lead">ヤギプライムの特典を見る</a>

          <div class="my-contents">

            <div class="my-contents_container">
              <h2 class="m-h2">解約の理由を教えてください。</h2>

              <div class="cancelreason">
                <label><el-checkbox v-model="reason1">ヤギプライムの担当エージェント経由で仕事が決まった</el-checkbox></label>
                <label><el-checkbox v-model="reason2">ヤギオファーにより仕事が決まった</el-checkbox></label>
                <label><el-checkbox v-model="reason3">上記以外で仕事が決まった</el-checkbox></label>
                <label><el-checkbox v-model="reason4">担当のエージェントに不満がある</el-checkbox></label>
                <label><el-checkbox v-model="reason5">価格が高いと感じる</el-checkbox></label>
                <label><el-checkbox v-model="reason6">転職・就職活動をやめたため必要がなくなった</el-checkbox></label>
                <label><el-checkbox v-model="reason7">その他（下欄にご記入ください）</el-checkbox></label>
                <div data-v-c4034964="" class="el-textarea"><textarea autocomplete="off" class="el-textarea__inner"
                    style="min-height: 83.1111px; height: 83.1111px;"></textarea>
                </div>
              </div>

              <div class="btn_container">
                <div class="btn01 btn03">
                  <p>お手数ですが、上記の解約理由のどれかを選択してください。</p>
                  <a href="#" @click="nextStep()" class="btn03_link">ヤギプライム会員資格を解約する</a>
                </div>

                <div class="btn01">
                  <a href="/mypage/yagiprime" class="btn01_link">特典と会員資格を継続</a>
                </div>
                <div class="btn01 btn02" v-if="false">
                  <a href="" class="btn01_link btn02_link">更新前にお知らせする</a>
                  <p class="btn-note">更新3日前にメールでお知らせします</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="mypage_back mypage_yagiprimecancel" v-else-if="step == 3">
        <div class="wrapper">
          <h2 class="m-h2">ヤギプライムを解約する</h2>
          <a href="" class="m-lead">ヤギプライムの特典を見る</a>

          <div class="my-contents">

            <div class="my-contents_container">
              <h2 class="m-h2">最後のステップです。</h2>
              <p class="m-attention">期間終了後、エージェントとのメッセージを含むプライムのお得な特典が全て受けられなくなります。<br>本当に解約しますか？</p>

              <div class="btn_container">
                <div class="btn01 btn03">
                  <a href="#" @click="cancelYagiprime()" class="btn03_link">ヤギプライム会員資格を解約する</a>
                </div>

                <div class="btn01">
                  <a href="/mypage/yagiprime" class="btn01_link">特典と会員資格を継続</a>
                </div>
                <div class="btn01 btn02" v-if="false">
                  <a href="" class="btn01_link btn02_link">更新前にお知らせする</a>
                  <p class="btn-note">更新3日前にメールでお知らせします</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="mypage_back mypage_yagiprimecancel" v-else-if="step == 4">
        <div class="wrapper">
          <h2 class="m-h2">ヤギプライムを解約する</h2>
          <a href="" class="m-lead">ヤギプライムの特典を見る</a>

          <div class="my-contents">

            <div class="my-contents_container">
              <h2 class="m-h2">解約を受け付けました。</h2>
              <p>ヤギプライム会員資格の解約を受け付けました。<br>
                ご利用いただきありがとうございました。<br>
                引き続き、履歴書作成サイト「yagish」をご利用ください。</p>

              <div class="btn_container">
                <div class="btn01 btn04">
                  <a href="/mypage" class="btn01_link btn04_link">マイページTOPに戻る</a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<style lang="css" src="@/assets/css/renew3_mypage.css"></style>
<style scoped>
@import "/static/css/slick-theme.css";
@import "/static/css/slick.css";
/* @import url("//unpkg.com/element-ui@2.15.13/lib/theme-chalk/index.css"); */
</style>

<script>
import {
  TabPane,
  Tabs,
  MessageBox
} from 'element-ui'
import LoginForms from '@/components/RenewLoginForms'
import Slick from 'vue-slick'
import firebase from 'firebase/app'
import MypageCommonMenu from '@/components/formats/CommonParts/MypageCommonMenu'

const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const DOC_PAPER_HEIGHT_PX = 794
export default {
  components: {
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    'login-forms': LoginForms,
    Slick
  },
  data: function () {
    return {
      reason1: 1,
      reason2: 1,
      reason3: 1,
      reason4: 1,
      reason5: 1,
      reason6: 1,
      reason7: 1,
      fullscreenLoading: false,
      recentEdit: {
        FormatId: ''
      },
      introData: {},
      backupList: {
        auto: [],
        user: []
      },
      dialogVisible: false,
      username: '',
      useremail: '',
      step: 1
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    nextStep: function () {
      this.step++
    },
    cancelYagiprime: function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = new FormData()

      const app = this
      this.$axios
        .delete(this.$varuna.endPoints.subscriptions + this.$firebase.user.uid + '/cancel/', formData, { timeout: 60000 })
        .then(function (response) {
          app.$message({
            message: '解約完了しました。',
            type: 'info'
          })
          app.nextStep()
        })
        .catch(function (error) {
          app.$message({
            message: '解約失敗しました。',
            type: 'error'
          })
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    authStateChanged: async function () {
      const app = this

      this.$iterateStorage(function (value, key, iterationNumber) {
        if (key === 'basicData') {
          app.formatData = value
        }
      }, function (err) { })

      console.log('mypage logined')
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('version', '2')
      formData.append('reqflg', '2')
      formData.append('email', this.$firebase.user.email)
      formData.append('site_flag', 'r')
      formData.append('device_flag', app.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('email_verified', this.$firebase.user.emailVerified ? '1' : '0')

      app.$axios
        .post(app.$varuna.endPoints.getMypageHistory, formData, { timeout: 60000 })
        .then(function (response) {
          app.mypagedata = response.data
          if (app.$firebase.user.displayName) {
            app.username = app.$firebase.user.displayName
            app.useremail = app.$firebase.user.email
          } else if (app.mypagedata.memberdata.lastname) {
            app.username = app.mypagedata.memberdata.lastname + " " + app.mypagedata.memberdata.firstname
            app.useremail = app.$firebase.user.email
          } else {
            app.username = app.$firebase.user.email
          }
          console.error(app.mypagedata.memberdata.offers)
          app.joblistKeyword = app.mypagedata.memberdata.keyword
          app.joblistArea = app.mypagedata.memberdata.area
          app.job_list = app.mypagedata.memberdata.offers.offers
          app.search_id = app.mypagedata.memberdata.offers.search_id

        })
        .catch(function (error) {
          if (app.$firebase.user.displayName) {
            app.username = app.$firebase.user.displayName
            app.useremail = app.$firebase.user.email
          } else {
            app.username = app.$firebase.user.email
          }
        }).finally(function () {
          app.fullscreenLoading = false
        })

      this.$axios
        .get(this.$varuna.endPoints.isSubscribed + this.$firebase.user.uid + '/', null, { timeout: 60000 })
        .then(function (response) {
          console.error(response.data.is_subscribed)
          app.$globalVar.isYagiPrime = response.data.is_subscribed
          if (!response.data.is_subscribed) {
            location.href = '/mypage'

          } else if (response.data.is_cancel) {
            alert('解約済です。詳細はマイページのアカウント情報にてご確認ください')
            location.href = '/mypage/account'

          }

        })
        .catch(function (error) {

        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  created: function () {

    const app = this
    app.fullscreenLoading = true
    return


  },
  beforeMount: function () {
    console.error("beforeMount:" + this.$route.query.custom_token)
    this.$eventHub.$on('firebase-initialized', this.authStateChanged)
  },
  destroyed: function () {
    this.$eventHub.$off('firebase-initialized', this.authStateChanged)
  }
}
</script>
